import { Component, Input } from "@angular/core";

@Component({
	selector: "app-title",
	template:
		'<div class="app-title" id="app-title" [style.direction]="textDirection" [innerHTML]="title"></div>',
	styles: [".app-title { font-size: 25px; }"],
})
export class TitleDirective {
	@Input()
	public title: string;

	@Input()
	public textDirection: string;

	constructor() {}
}
